
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCu8gbnK-5qyWvM8rdPs4RKqcal-5RrUnY",
  authDomain: "chatapp-1b49b.firebaseapp.com",
  projectId: "chatapp-1b49b",
  storageBucket: "chatapp-1b49b.appspot.com",
  messagingSenderId: "702132219106",
  appId: "1:702132219106:web:e6616163d546611b1b42bb"
};


export const app = initializeApp(firebaseConfig);